import { render, staticRenderFns } from "./AufstellungComp.vue?vue&type=template&id=39f53d36&scoped=true&"
import script from "./AufstellungComp.vue?vue&type=script&lang=ts&"
export * from "./AufstellungComp.vue?vue&type=script&lang=ts&"
import style0 from "./AufstellungComp.vue?vue&type=style&index=0&id=39f53d36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f53d36",
  null
  
)

export default component.exports